import $ from "jquery"

// Expose jQuery globally for legacy plugins
window.$ = $
window.jQuery = $
